import { TFunction } from 'react-i18next'
import * as yup from 'yup'
import { type FormFieldsAccountUser } from 'types/types'
import { validEmailRegex } from 'utils/email'

export interface TeamMemberEditorFormFields extends FormFieldsAccountUser {
  approver?: boolean
}

export const teamMemberEditorSchema = (t: TFunction<'translation', undefined>) => {
  const emailAddress = yup
    .string()
    .trim()
    .required(t('emailRequired'))
    .matches(new RegExp(validEmailRegex), t('validEmailRequired'))

  const groups = yup.array().min(1, t('selectOneOption')).required(t('selectOneOption'))

  const approver = yup.boolean().notRequired()

  const formFields = {
    emailAddress,
    groups,
    approver,
  }

  return yup.object(formFields)
}
